import { FilterList } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { FilterDrawer } from "./FilterDrawer";
import { useTranslation } from "../../../../../hooks/useTranslation";

export const FiltersButton = ({
  isPendingApprove,
}: {
  isPendingApprove: boolean;
}) => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const { translate } = useTranslation();

  return (
    <>
      <Button
        variant="outlined"
        onClick={toggleDrawer(true)}
        startIcon={<FilterList />}
      >
        {translate("filters.filters")}
      </Button>
      <FilterDrawer
        open={open}
        onClose={toggleDrawer(false)}
        isPendingApprove={isPendingApprove}
      />
    </>
  );
};
